
import CustomTable from "../../../core/components/common/custom-table.component"
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CustomeStatusLabel from '../../../core/components/ui/custom-status-label.component'
import CustomPopper from '../../../core/components/common/custom-popper.component'
import { menuItemsTemplate, getConditionalMenuItems } from '../utils/roleMenuConfig';
import { useEffect, useState } from "react";
import EditRoleModal from "./edit-role-modal.component";
import DeactivateRole from "./deactivate-role.component"
import ActivateRole from "./activate-role.component"
import DeleteRole from "./delete-role.component";
import RoleManagementService from "../services/api/role-managment-service";
import moment from 'moment';
import { useSnackbar } from "notistack";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import {useNavigate} from "react-router-dom";


const RoleListViewTable = ({recordChange, setRecordChange}) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [openDeactivate, setOpenDeactivate] = useState(false)
    const [openActivate, setOpenActivate] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [row, setRow] = useState(null);
    const [rows, setRows] = useState([])
    const { enqueueSnackbar } = useSnackbar();

    const handleRecordChange = () => setRecordChange(true)

    const fetchData = () => {
        setLoading(true)
        RoleManagementService.getList().then((res) => {
            let apiResponse = res.data;
            console.log("apiResponse", apiResponse)
            setRows(apiResponse.data)

        }).catch((error) => {
            const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 2000
            })
          
        }).finally(()=>{
            setLoading(false)
        })
    };
          
    // run this function onPageLoad
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(()=>{
        if(recordChange) {
            fetchData();
            setRecordChange(false)
        }
    },[recordChange])

    // headers
    const headers = [
        {label: "ID"},
        {label: "Role Name"},
        {label: "Profile Type"},
        {label: "Description"},
        {label: "Status"},
        {label: "Last Date Modified"},
        {label: "Action"}
    ]

    const handleAction = (row, setOpenAction) => {
        setRow(row);
        setOpenAction(true);
    };

    const handleEdit = (row) => { 
        handleAction(row, setOpenEdit);
    };

    const handleDeactivate = (row) => {
        handleAction(row, setOpenDeactivate);
    }

    const handleActivate = (row)=> {
        handleAction(row, setOpenActivate);
    }

    const handleDelete = (row) => {
        handleAction(row, setOpenDelete);
    }

    const handleGatePassConfiguration = (row) => {
        navigate("/rbac/gatepass-configuration?role=" + row?.role);
    }


    return (
        <div>
            <CustomTable headers={headers}>
                {rows.map((row) => {
                    let menuItems = getConditionalMenuItems(row, menuItemsTemplate(row, handleEdit, handleDeactivate, handleDelete, ...(row?.profile_type === "Port Employee" && row?.role === "Admin" ? [] : [handleGatePassConfiguration])), handleActivate); // action conditional display

                    const formattedDate = moment(row.updated_at).format('MMMM Do YYYY, h:mm:ss a');
                    return (
                    <TableRow key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.role}</TableCell>
                        <TableCell>{row.profile_type}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell><CustomeStatusLabel label={ row.active ? "Active":"Inactive" } /></TableCell>
                        <TableCell>{formattedDate}</TableCell>
                        <TableCell><CustomPopper row={row} icon={MoreVertIcon} menuItems={menuItems}/></TableCell>
                    </TableRow>
                    )
                })}
            </CustomTable>
            {loading && (
                <CustomListviewLoader/>
            )}
            <EditRoleModal openEdit={openEdit} row={row} setOpenEdit={setOpenEdit} handleRecordChange={handleRecordChange}  />

            <DeactivateRole row={row} open={openDeactivate} setOpen={setOpenDeactivate} handleRecordChange={handleRecordChange} />
            <ActivateRole row={row} open={openActivate} setOpen={setOpenActivate} handleRecordChange={handleRecordChange} />
            <DeleteRole row={row} open={openDelete} setOpen={setOpenDelete} handleRecordChange={handleRecordChange} />
            
        </div>
    )
}

export default RoleListViewTable